<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="row r2">
    <div class="col-2">
      <app-results-sidebar></app-results-sidebar>
    </div>
    <div class="col results-main-body">
      <div class="row app-tab">
        <app-tab></app-tab>
      </div>
      <div class="row" style="margin-bottom:50px;">

        <ng-container *ngIf="(activeSideTab$ | async) === 'company_technology_summary'">
          <app-company-technology-summary [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null">
          </app-company-technology-summary>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'innovation_activity_over_time'">
          <app-innovation-activity-over-time [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [query]="(getParams() | async)?.params?.query || null">
          </app-innovation-activity-over-time>
        </ng-container>


       
        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_exec_summary'">
          <app-theme-exec-summary [tabId]="activeTab$ | async" [query]="(getParams() | async)?.params?.query || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [theme_params]="(getParams() | async) ||null">
          </app-theme-exec-summary>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_performance_history'">
          <app-thematic-performance-history [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null" [tab_name]="(getParams() | async)?.tab_name || null"
            [theme_params]="(getParams() | async) ||null">
          </app-thematic-performance-history>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_innovation_activity'">
          <app-thematic-innovation-activity [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null" [tab_name]="(getParams() | async)?.tab_name || null"
            [theme_params]="(getParams() | async) ||null">
          </app-thematic-innovation-activity>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_technology_summary'">
          <app-thematic-technology-summary [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null" [tab_name]="(getParams() | async)?.tab_name || null"
              [theme_params]="(getParams() | async) ||null">
          </app-thematic-technology-summary>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_public_competitors'">
          <app-thematic-competitors-table-v2 [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [mode]="'public'"
              [theme_params]="(getParams() | async) ||null">
          </app-thematic-competitors-table-v2>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_custom_peer_group'">
          <app-thematic-competitors-table-v2 [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [mode]="'custom'"
              [theme_params]="(getParams() | async) ||null">
          </app-thematic-competitors-table-v2>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'company_private_competitors'">
          <app-competitors-table-v2 [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null" [mode]="'private'"
            >
          </app-competitors-table-v2>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'company_public_competitors'">
          <app-competitors-table-v2 [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null" [mode]="'public'">
          </app-competitors-table-v2>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'thematic_private_competitors'">
          <app-thematic-competitors-table-v2 [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null" [mode]="'private'"
              [theme_params]="(getParams() | async) ||null">
          </app-thematic-competitors-table-v2>
        </ng-container>
        <ng-container *ngIf="(activeSideTab$ | async) === 'competitive_benchmarking_peergroup'">
          <app-competitors-table-v2 [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null" [mode]="'custom'">
          </app-competitors-table-v2>
        </ng-container>

        <ng-container *ngIf="(activeSideTab$ | async) === 'executive_summary'">
          <app-exec-summary-v2 [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [gsubind]="(getParams() | async)?.params?.gsubind || null">
          </app-exec-summary-v2>
        </ng-container>



        <!--MARK: Inventions View-->
        <ng-container *ngIf="(activeSideTab$ | async) === 'inventions_view'">
          <app-inventions-view [tabId]="activeTab$ | async"
            [query]="(getParams() | async)?.params?.query || null"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [theme_search_type]="(getParams() | async)?.params?.theme_search_type || null"
            [cluster_id]="(getParams() | async)?.params?.cluster_id ?? null"
            [cluster_name]="(getParams() | async)?.params?.cluster_name ?? null">
          </app-inventions-view>
        </ng-container>    

        <ng-container *ngIf="(activeSideTab$ | async) === 'innov_metrics_history'">
          <app-innovation-metrics-activity [tabId]="activeTab$ | async"
            [entityids]="(getParams() | async)?.params?.entityids || null"
            [tab_name]="(getParams() | async)?.tab_name || null"
            [entity_data]="(getParams() | async)?.params?.entity_data || null">
          </app-innovation-metrics-activity>
        </ng-container>


      </div>

    </div>
  </div>
</div>
<router-outlet></router-outlet>